import React, { useCallback, useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import brazilStyles from './brazil.styles';
import SeparationWorklistPage from '../Common/SeparationWorklist/SeparationWorklistPage';
import LABEL_SEPARATION_QC_OPTIONS from '../Common/SeparationWorklist/qcStatusOptions';
import { SeparationWorklistConfig, WorklistRow } from '../Common/SeparationWorklist/types';
import BrazilLabelSeparationDialog from './BrazilLabelSeparationDialog';

const BRAZIL_API_BASE = '/brazil';

const PdfToLabelListing = () => {
  const [viewerOpen, setViewerOpen] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(null);
  const [worklistRefreshToken, setWorklistRefreshToken] = useState(0);
  const [dialogSaving, setDialogSaving] = useState(false);

  const handleOpenLabelSeparation = useCallback((row: WorklistRow) => {
    setSelectedDocumentId(row.document_id);
    setViewerOpen(true);
  }, []);

  const handleCloseViewer = useCallback(() => {
    setViewerOpen(false);
    setSelectedDocumentId(null);
    setDialogSaving(false);
  }, []);

  const handleDialogClose = useCallback(() => {
    if (dialogSaving) {
      return;
    }
    handleCloseViewer();
  }, [dialogSaving, handleCloseViewer]);

  const handleSaved = useCallback(() => {
    setWorklistRefreshToken(current => current + 1);
  }, []);

  const config = useMemo<SeparationWorklistConfig>(
    () => ({
      apiBasePath: BRAZIL_API_BASE,
      stage: 'label_separation',
      searchLabel: 'Registration / Process / Submission ID',
      qcStatusOptions: LABEL_SEPARATION_QC_OPTIONS,
      rowActions: [
        {
          label: 'Multi Label Separation',
          getVariant: row => (row.separation ? 'contained' : 'outlined'),
          onAction: handleOpenLabelSeparation
        }
      ]
    }),
    [handleOpenLabelSeparation]
  );

  return (
    <>
      <SeparationWorklistPage config={config} refreshToken={worklistRefreshToken} />
      <Dialog
        open={viewerOpen}
        onClose={handleDialogClose}
        disableEscapeKeyDown={dialogSaving}
        sx={brazilStyles.backdropDialog}
        maxWidth='xl'
        fullWidth>
        {selectedDocumentId ? (
          <BrazilLabelSeparationDialog
            documentId={selectedDocumentId}
            onClose={handleCloseViewer}
            onSaved={handleSaved}
            onSavingChange={setDialogSaving}
          />
        ) : null}
      </Dialog>
    </>
  );
};

export default PdfToLabelListing;
